<template>
  <section>
    <v-container fluid>
      <v-data-table
          dense
          :headers="table_data.headers"
          :items="table_data.items"
          item-key="name"
          class="elevation-1"
      >
        <template v-slot:item.study_sub_group.p1_exam_dates="{ value }">
          <p class="ma-0" v-for="(item, idx) in value" :key="idx">{{ $moment(item).format('DD/MM/YYYY') }}, </p>
        </template>
        <template v-slot:item.study_sub_group.p2_exam_dates="{ value }">
          <p class="ma-0" v-for="(item, idx) in value" :key="idx">{{ $moment(item).format('DD/MM/YYYY') }}, </p>
        </template>
        <template v-slot:item.training_start="{ value }">
          <template v-if="value">{{ $moment(value).format('DD/MM/YYYY hh:mm A') }}</template>
        </template>
        <template v-slot:item.training_end="{ value }">
          <template v-if="value">{{ $moment(value).format('DD/MM/YYYY hh:mm A') }}</template>
        </template>
        <template v-slot:item.client.sunday_day_off="{ value }">
          {{ Boolean(value) }}
        </template>

      </v-data-table>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    table_data: {
      headers: [
        { text: 'Group', value: 'study_group.name' },
        { text: 'Sub group', value: 'study_sub_group.name' },
        { text: 'P1 exams', value: 'study_sub_group.p1_exam_dates' },
        { text: 'P2 exams', value: 'study_sub_group.p2_exam_dates' },
        { text: 'Visit group', value: 'visitation_type' },
        { text: 'Sunday day off', value: 'sunday_day_off' },
        { text: 'Training start', value: 'training_start' },
        { text: 'Training end', value: 'training_end' },
        { text: 'Status', value: 'status' },



      ],
      items: [],
    }
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/students/${this.$route.params.student_id}/study-groups`)
          .then(({data}) => data.data)
    },

  }
}
</script>